export interface RuntimeConfig {
  apiUrl: string;
  authMode: 'cognito' | 'dev';
  cognitoUserPoolId?: string;
  cognitoClientId?: string;
  devJwtSecret?: string;
}

let current: RuntimeConfig | null = null;

/** In AWS la configurazione arriva da /config.json (scritto dall'infrastruttura); in locale dalle variabili Vite. */
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (current) return current;
  try {
    const r = await fetch('/config.json', { cache: 'no-store' });
    if (r.ok && r.headers.get('content-type')?.includes('json')) {
      current = (await r.json()) as RuntimeConfig;
      return current;
    }
  } catch {
    /* sviluppo locale */
  }
  current = {
    apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:3000',
    authMode: (import.meta.env.VITE_AUTH_MODE as 'dev' | 'cognito' | undefined) ?? 'dev',
    cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    devJwtSecret: import.meta.env.VITE_DEV_JWT_SECRET,
  };
  return current;
}

export function runtimeConfig(): RuntimeConfig {
  if (!current) throw new Error('Configurazione non caricata');
  return current;
}

export function setRuntimeConfigForTests(c: RuntimeConfig): void {
  current = c;
}
